import { getFBaseToken } from "core/hooks/useGetFirebaseToken";
import { IParams, tryFetch } from "helpers/FetchAPI";
import { getTokenOrDefault } from "helpers/Storage";

const token = getTokenOrDefault();

export const RequestFCMPermission = async () => {
  const TOKEN = await getFBaseToken();

  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      try {
        if (TOKEN) {

          const params: IParams = {
            url: `/g/fcm`,
            method: "POST",
            token: token,
            payload: { token: TOKEN },
          };

          await tryFetch(params);
        }
      } catch (error) {
        console.error("Error getting FCM token:", error);
      }
    } else {
      console.log("Notification permission denied.");
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
  }
};
